import * as React from "react";
import { Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../actions";
import strings from "./Localization";
import userManager from "../helpers/UserManager";

class EnsureContentAccessRights extends React.Component {
    state = { checking: true, isAuthenticated: false };

    async componentDidMount() {
        const { location } = this.props;
        const path = (location.pathname || "").toLowerCase();

        if (
            path.startsWith("/logincallback")
      || path.startsWith("/logoutcallback")
      || path.startsWith("/login")
        ) {
            this.setState({ checking: false, isAuthenticated: true });
            return;
        }

        const user = await userManager.getUser();
        const isAuthenticated = !!(user && !user.expired && user.access_token);

        this.setState({ checking: false, isAuthenticated });
    }

    render() {
        const { currentuser, location, children } = this.props;
        const path = (location.pathname || "").toLowerCase();

        if (
            path.startsWith("/logincallback")
      || path.startsWith("/logoutcallback")
      || path.startsWith("/login")
        ) {
            return children || null;
        }

        // Loading pending check auth
        if (this.state.checking) {
            return <div style={{ padding: 24 }}>{strings.Loading}</div>;
        }

    // Not connected => /login
        if (!this.state.isAuthenticated) {
            return (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: { from: location.pathname + location.search }
                    }}
                />
            );
        }

    // Connected => check permission (40, create) > 10
        const hasAccess
      = currentuser
      && currentuser.accessrights
      && typeof currentuser.accessrights.hasPermission === "function"
      && currentuser.accessrights.hasPermission(40, "create") > 10;

        if (hasAccess) {return children;}


    // Connected but not have accessrights
        return (
            <Redirect
                to={{
                    pathname: "/login",
                    state: { from: location.pathname + location.search }
                }}
            />
        );
    }
}

const mapStateToProps = (state) => state;
const mapDispatchToProps = (dispatch) => bindActionCreators(ActionsCreators, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnsureContentAccessRights));
